import React, { ReactElement } from "react";
import styled from "styled-components";
import { Layout } from "antd";
import { Logo } from "icons";
import { theme } from "theme/theme";

const { Footer } = Layout;

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  margin-top: 48px;

  ${theme.media.tablet} {
    align-items: center;
  }
  ${theme.media.laptopL} {
    margin-top: 40px;
    align-items: unset;
  }
`;

const Container = styled.div`
  margin: 0 auto;
`;

const WrapperLogo = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

const WrapperContent = styled.div`
  position: relative;
  background: ${theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);
  width: 300px;
  ${theme.media.mobileM} {
    width: 343px;
  }
  ${theme.media.tablet} {
    width: 450px;
  }
`;

const CopyRight = styled.div(({ theme }) => ({
  color: theme.colors.border,
  fontSize: theme.sizes.xs,
  fontWeight: theme.fontWeight.medium,
}));

const FooterStyled = styled(Footer)`
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 16px 0;
  ${theme.media.laptop} {
    padding: 24px 0;
    bottom: -45px;
  }
`;

const CreateFormLayout: React.FC = ({ children }): ReactElement => {
  console.log(window.screen.height, "window.screen.height;");
  return (
    <Wrapper>
      <Container>
        <WrapperLogo>
          <Logo />
        </WrapperLogo>
        <WrapperContent>{children}</WrapperContent>
      </Container>
      <FooterStyled>
        <CopyRight>© 2020 by LEBER, Inc. All Rights Reserved.</CopyRight>
      </FooterStyled>
    </Wrapper>
  );
};

export default CreateFormLayout;
